export default "__VITE_ASSET__BY9y5M68__"